/**
 * 位置消息组件
 */
import React from "react";
import "./index.less";
import { connect } from "dvajs";
import { getImgSrc } from "@/utils/chat/index";
import locationDefault from "@/assets/location_default.png";

interface LocationProps {
  message: any;
}

type ILocationProps = Readonly<LocationProps>;

function Location({ message }: ILocationProps) {
  return (
    <div
      className="location-box"
      onClick={() => {
        console.log("位置消息组件", message);
        window.open(message.url);
      }}
    >
      <div className="location-box-info">
        <div className="ellipsis info-title">{message.title}</div>
        <div className="ellipsis info-label">{message.label}</div>
      </div>
      <div className="location-box-image">
        <img
          src={getImgSrc(message.image)}
          onError={(e: any) => {
            if (e.target) {
              e.target.src = locationDefault;
            }
          }}
        />
      </div>
    </div>
  );
}

function mapStateToProps({ chat }: any) {
  return {
    selectedSession: chat.selectedSession
  };
}

function mapDispatchToProps(dispatch: any) {
  return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(Location);
